#import "./AllPriceBreakdown.gql"
#import "./BookingTicketDetails.gql"
#import "./BookingPaymentDetails.gql"
fragment DetailedBookingDetails on BookingNode {
  id
  reference
  expired
  expiresAt
  status
  accessibilityInfo
  previousAccessibilityInfo
  accessibilityInfoUpdatedAt
  user {
    id
    firstName
    lastName
  }
  salesBreakdown {
    totalPayments
  }
  priceBreakdown {
    ...AllPriceBreakdown
  }
  ...BookingTicketDetails
  ...BookingPaymentDetails
  performance {
    id
    production {
      id
      name
      slug
    }
    start
    end
    doorsOpen
    isRelaxed
    relaxedName
    relaxedCategories {
      id
      shortDescription
      longDescription
    }
    venue {
      id
      slug
    }
    durationMins
    intervalDurationMins
  }
  canModifyAccessibility
}
